module.exports = __webpack_public_path__ + "img/twitter-square.4b3449dc.svg";